module.exports = __webpack_public_path__ + "media/images/android_icon-31898f27a12ba69f018dbb55acccfdc6.svg";